export * from './customer-profile.service';
export * from './customer-accounts.service';
export * from './corporate-accounts.service';
export * from './file.download.service';
export * from './attachment-type-service';
export * from './kyc.service';
export * from './onfido.service';
export * from './integration-module.service';
export * from './ariadnext.service';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/api/service/index.ts